var React = require('react');

function IconHorn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M567 161.4s-22-63.5-76.6-15.5C435.9 194 305.6 313.8 305.6 313.8H66.1c-1.7 0-3.1 1.4-3.1 2.9l1.3 382c0 1.6 1.3 2.9 2.9 2.9H295L492.5 873c28.7 24.9 74.5 37.8 74.5-20V161.4zM812.3 214.7c-31.4-21-77.5 22.1-58.4 48.3 80.8 67.9 128.8 163.3 123.4 267.3-4.9 94.5-52.8 178.6-127.2 239.4-25.9 31.1 35.6 66.2 56.1 50.3 89.2-72.8 146.7-173.6 152.5-286.7 6.4-123.8-50.5-237.5-146.4-318.6z","key":0}),React.createElement("path",{"d":"M639.3 675.2c-22.6 27.7 27 64.7 54.3 44.7 57.9-50.2 95-117.9 98.9-193.4 4.4-84.5-33.6-162.3-98-218.6-31.7-23.7-76.6 21.3-56.8 42.5 51.9 44.2 82.6 106 79.2 173.2-3.1 59.2-32.2 112.3-77.6 151.6z","key":1})]);
}

IconHorn.displayName = "IconHorn";

IconHorn.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconHorn;

IconHorn.default = IconHorn;
